import { render, staticRenderFns } from "./InterestList.vue?vue&type=template&id=d6d73a90"
import script from "./InterestList.vue?vue&type=script&lang=js"
export * from "./InterestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports